/**
 * Build-time feature flags. A flag that is off hides a feature's UI while its code stays in place.
 */
export const features = {
    /** The "Edit system prompt" button and "Custom system prompt" badge of the AI helpers */
    systemPromptEditing: false,
}
